import * as Pikaday from "pikaday";
import {PikadayOptions} from "pikaday";

interface PikadayImport {
    PikadayClass: PikadayConstructor,
}

export type PikadayConstructor = {
    new (options: PikadayOptions): Pikaday;
    readonly prototype: Pikaday;
};


export default class PikadayLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<PikadayImport>;

    private static instance: PikadayImport;

    public static load(): Promise<PikadayImport>{
        if(PikadayLoader.status == 0) {
            PikadayLoader.status = 1;

            PikadayLoader.promise = Promise.all([

                import(/* webpackChunkName: "pikaday-css" */ '../style/pikaday.css'),
                import(/* webpackChunkName: "pikaday-core" */ 'pikaday'),

            ]).then(v => {
                console.log("----------- PIKADAY LOADER", v);

                let core = v[1];

                console.log("----", (core as any).default);
                console.log("----", (core as any).default as Pikaday);

                let exp = {
                    PikadayClass: ((core as any).default)
                } as unknown as PikadayImport;

                PikadayLoader.instance = exp;
                PikadayLoader.status = 2;

                return exp;

            });

            return PikadayLoader.promise;
        }else if(PikadayLoader.status == 1){
            return PikadayLoader.promise;
        }else {
            return Promise.resolve(PikadayLoader.instance);
        }
    }

}